<section class="child">
    <div class="excel-report sidebar-note">
        <h1>{{'admin.reports.excelReport.name'|translate}}</h1>
        <p>{{'admin.reports.excelReport.choose.description'|translate}}</p>
    </div>
</section>